import React, {useState, useEffect} from 'react';
import {Table, Input, Form, message} from "antd";

const EditableCell = ({
                          editing,
                          dataIndex,
                          title,
                          inputType,
                          record,
                          index,
                          children,
                          ...restProps
                      }) => {
    return (
        <td {...restProps}>
            {editing ? (
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <p style={{
                        margin: '7px 5px 0px 0px',
                        alignSelf: 'baseline'
                    }}>{record.cell.getTypeCode()}</p>
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                        rules={[
                            {
                                required: true,
                                message: `This field is required`,
                            },
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                </div>
            ) : (
                children
            )}
        </td>
    );
};

const showMessage = (typeofMessage, content) => {
    message[typeofMessage]({content, style: {marginTop: '45px'}, duration: 2})
};

export const CYNYSymbolTable = ({selectedObject, originData, onUpdateSymbolData, graph}) => {
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState('');
    useEffect(() => {
        return () => {
            cancel();
        }
    }, [selectedObject])

    const isEditing = record => record.key === editingKey;


    const formatValue = (record) => {
        return record.value.slice(record.cell.getTypeCode().length, record.value.length);
    }


    const edit = record => {
        form.setFieldsValue({
            ...record,
            value: formatValue(record)
        });
        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey('');
    };

    const save = async (record) => {
        const row = await form.validateFields();
        const value = record.cell.getTypeCode() + row.value.trim();
        if (graph.validatePackageName(selectedObject, value)) {
            onUpdateSymbolData(value, record.value);
            setEditingKey('');
        } else {
            showMessage('error', `There is already a symbol with the name: ${value}`);
        }
    }

    const columns = [
        {
            title: 'Property',
            dataIndex: 'property',
            width: '35%',
            editable: false,
        },
        {
            title: 'Value',
            dataIndex: 'value',
            width: '35%',
            editable: true,
        },
        {
            title: '',
            width: '15%',
            dataIndex: 'operation',
            render: function (_, record) {
                if (record.isEdit) {
                    const editable = isEditing(record);
                    return editable ? (
                        <p style={{margin: 0}}>
                            <a
                                href="#"
                                style={{marginRight: '7px'}}
                                onClick={() => save(record)}

                            >
                                Save
                            </a>
                            <a href="#"
                               onClick={cancel}>Cancel</a>
                        </p>
                    ) : (
                        <a onClick={() => edit(record)}>
                            Edit
                        </a>
                    );
                } else {
                    return null
                }

            },
        },
    ];
    const mergedColumns = columns.map(col => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: record => ({
                record,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    return (
        <Form form={form} component={false}>
            <Table
                components={{body: {cell: EditableCell}}}
                bordered
                dataSource={originData}
                columns={mergedColumns}
                rowClassName="editable-row"
                size="small"
                pagination={{
                    onChange: cancel,
                }}
            />
        </Form>
    );
};
